import { render, staticRenderFns } from "./rateLog.vue?vue&type=template&id=5356ce69&scoped=true&"
import script from "./rateLog.vue?vue&type=script&lang=js&"
export * from "./rateLog.vue?vue&type=script&lang=js&"
import style0 from "./rateLog.vue?vue&type=style&index=0&id=5356ce69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356ce69",
  null
  
)

component.options.__file = "rateLog.vue"
export default component.exports